module.exports = __webpack_public_path__ + "media/home/logo_dark-6ab49ab5.svg";